/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Display_Next_Calls_DescriptionInputs */

const fr_settings_display_next_calls_description = /** @type {(inputs: Settings_Display_Next_Calls_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher les arrêts suivants (si disponibles).`)
};

const en_settings_display_next_calls_description = /** @type {(inputs: Settings_Display_Next_Calls_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show upcoming stops (when available).`)
};

/**
* | output |
* | --- |
* | "Show upcoming stops (when available)." |
*
* @param {Settings_Display_Next_Calls_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_display_next_calls_description = /** @type {((inputs?: Settings_Display_Next_Calls_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Display_Next_Calls_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_display_next_calls_description(inputs)
	return en_settings_display_next_calls_description(inputs)
});